import {TOKENS} from '../../tokens'

export const link = {
  dark: {
    text: TOKENS.dark.positive_700,
    textHover: TOKENS.dark.positive_700,
  },
  light: {
    text: TOKENS.light.custom_accent,
    textHover: TOKENS.light.custom_accent,
  },
} as const
